import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'budget',
    loadChildren: () => import('./features/budget/budget.routes')
                            .then(m => m.BUDGET_ROUTES)
  },
  {
    path: 'auth',
    loadChildren: () => import('./features/login/login.routes')
                            .then(m => m.LOGIN_ROUTES)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./features/dashboard/dashboard.routes')
                            .then(m => m.DASHBOARD_ROUTES)
  },
  {
    path: 'users',
    loadChildren: () => import('./features/users/users.routes')
                            .then(m => m.USERS_ROUTES)
  }
];